import { Component } from '@angular/core';
import { IzePipe } from '@assetaccountant/core/pipes/ize.pipe';

@Component({
  selector: 'app-expired-organisation-invite',
  templateUrl: './expired-organisation-invite.component.html',
  standalone: false,
})
export class ExpiredOrganisationInviteComponent {
  get title() {
    return {
      pageTitle: this.izePipe.transform('Expired Organisation Invite'),
    };
  }

  constructor(private izePipe: IzePipe) {}
}
